export default __webpack_public_path__ + "static/media/instructionForExecutiveSummaryPage.166c19e2.png";